import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BpgEventsService } from '../../bpg-events/bpg-events.service';

import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';

@Component({
  selector: 'app-survey-preview',
  templateUrl: './survey-preview.component.html',
  styleUrls: ['./survey-preview.component.css']            
})
export class SurveyPreviewComponent implements OnInit {
  allSelectedQuestions : any =[] ;
  stdQuestionAnswers : any =[];
  selectedAnswers : any = [];
  surveyDetail = [];
  eventDetails : any;
  eventName :string;
  msg1:string;
  previewMethod :string;
  landingData:any;
  loginData: any;
  loginUserId : number;
  loginUserName : String;
  alertSuccess: boolean;
  adminId:any;
  loginDetails: any;
  isbpgAdmin: boolean = false;
  isbpgLeadAdmin = false;
  constructor(private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    private bpgEventsService : BpgEventsService,
    
    private environment : EnvironmentConfiguration) { }

  ngOnInit() {
    if(this.environment.envName == 'dev' || this.environment.envName == 'qa' || this.environment.envName == 'prod'){
   if(localStorage.getItem('loginData') == null || localStorage.getItem('loginData') == undefined ){
      this.router.navigate(['/log-out']);
    }}
    this.loginDetails = JSON.parse(localStorage.getItem("loginData"));
    this.adminId = localStorage.getItem('adminId');
    
    if(localStorage.getItem('isbpgAdmin') == 'true')
    {
      this.isbpgAdmin = true
    }
    if(localStorage.getItem('isbpgLeadAdmin') === 'true')
    {
      this.isbpgLeadAdmin = true
    }
   if(this.adminId !== 1 && this.adminId !== 2 && this.adminId !== 3 && !this.isbpgAdmin && !this.isbpgLeadAdmin)
    {
      this.router.navigate(['/site-home']);
    }
    // if(this.loginDetails == null){
    //   this.router.navigate(['/login']);
    // }
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
   
    this.spinnerService.show();
    this.stdQuestionAnswers = JSON.parse(sessionStorage.getItem("stdQuestionAnswers"));
    this.allSelectedQuestions = JSON.parse(sessionStorage.getItem("allSelectedQuestions"));
    this.surveyDetail = JSON.parse(sessionStorage.getItem("surveyDetails"));
    this.eventDetails = JSON.parse(sessionStorage.getItem("eventDetails"));

    this.eventName=this.eventDetails.eventName;

    for(let i=0;i<this.allSelectedQuestions.length;i++){
      for(let j=0;j<this.stdQuestionAnswers.length;j++){
        if(this.allSelectedQuestions[i].questionId == this.stdQuestionAnswers[j].questionId ){
            this.selectedAnswers.push(this.stdQuestionAnswers[j]);
      }
    }

    setTimeout(function(){
      this.spinnerService.hide();
    }.bind(this), 1500);
    
  }
  this.loginData = JSON.parse(localStorage.getItem('loginData'));
  this.loginUserId = this.loginData.userId;
  this.loginUserName = this.loginData.userFirstName+" "+this.loginData.userLastName;
}

/** to select cancel
   * @class SurveyPreviewComponent
   * @method cancelClick
   */
  cancelClick(){
    this.previewMethod = "navigate";
    this.msg1=" Are you sure you want to leave this page ?";
  }
  navigate(){
    this.router.navigate(['/create-survey']);
  }

  /** to submit survey
   * @class SurveyPreviewComponent
   * @method submit
   */
  launch(){

    document.getElementById("launchButton").setAttribute('data-toggle','modal');
    document.getElementById("launchButton").setAttribute('data-target','#myModal');
    this.previewMethod = "submit";
    this.msg1=" Are you sure you want to launch survey ?";
    
  }

  submit(){
    this.spinnerService.show();
    this.landingData= {
      "createdBy": this.loginUserName, 
      "endDate": this.surveyDetail[1],
      "eventId": this.eventDetails.eventId,
      "isActive": true,
      "modifiedBy": this.loginUserName,
      "startDate": this.surveyDetail[0],
      "surveryDesc": this.surveyDetail[2],
      "surveyLaunchAdmin": this.loginUserId,
      "surveyQuestions": [
       
      ]
    }
    
    for(let i=0;i<this.selectedAnswers.length;i++){
      this.landingData.surveyQuestions.push(
        {
          "createdBy": this.loginUserName,      
          "isActive": true,
          "modifiedBy": this.loginUserName,   
          "survey": {           
          },
          "surveyQuestion": {            
            "surveyQuestionId": this.selectedAnswers[i].questionId
          },
          "surveyQuestionId":  this.selectedAnswers[i].questionId
        }
      )
    }
    this.bpgEventsService.createSurvey(this.landingData).subscribe(data=>{
      this.spinnerService.hide();
      this.alertSuccess = true;
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      setTimeout(function() {         
        this.alertSuccess = false;
        this.router.navigate(['/event-view-details']);
      }.bind(this), 6000 );

    })
  }

}
